import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import PageTemplate from "../Templates/PageTemplate";
import middleware from '../Api/Middleware';
import ToastWarning from '../Toasts/ToastWarning';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import ToastError from '../Toasts/ToastError';
import placeholder from './Icons/empty-placeholder.jpg';
import Backbutton from "../Products/subpages/images/BackIcon.svg";
import { BorderedDropDown } from '../HouseStyle/Components/DropDowns';
import CustomerComponent from './Components/CustomerComponent';
import JsBarcode from 'jsbarcode';
import { BackButton, ButtonBlue } from '../HouseStyle/Components/Buttons';
import ToastPromise from '../Toasts/ToastPromise';
import { generateInvoice } from '../generatePDF/GenerateInvoice';
import { AddressKinds } from '../Enums/addressKinds';

const ProccessOrders = () => {
  const { order_number } = useParams();

  const navigate = useNavigate();
  const [pageIsLoading, setPageIsLoading] = useState(true);

  const [order, setOrder] = useState([]);
  const [soldProducts, setSoldProducts] = useState([]);
  const [productsToProcces, setProductsToProcces] = useState([]);
  const [productsToProccesFullyShown, setProductsToProccesFullyShown] = useState([]);
  const [proccessingProducts, setProccessingProducts] = useState([]);
  const [makeNewPackage, setMakeNewPackage] = useState(true);
  const [packageAmount, setPackageAmount] = useState(1);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [invoiceAddress, setInvoiceAddress] = useState(null);
  const [customer, setCustomer] = useState({});
  const [emails, setEmails] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [barcode, setBarcode] = useState('');
  const [barcodeURL, setBarcodeURL] = useState("");
  const [packages, setPackages] = useState([]);
  const [showShipmentMethod, setShowShipmentMethod] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [invoiceNote, setInvoiceNote] = useState('');
  const [reference, setReference] = useState('');
  const [exportShippingInstalled, setExportShippingInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));

  useEffect(() => {
    (async () => {
      try {
        const ordersResponse = await middleware.get(`orders/fullorder?order_number=${order_number}`);
        if (!ordersResponse.data.data) {
          ToastError(`Deze bestelling bestaat niet.`);
          navigate(`/bestellingen`);
          return;
        }
        const order = ordersResponse.data.data;
        
        // Check if the order is cancelled
        if (order.order_status === 0) {
          ToastWarning(`Deze bestelling is geannuleerd en kan niet meer worden verwerkt.`);
          navigate(`/bestellingen/overzicht/${order_number}`);
          return;
        }

        setOrder(order);
        setInvoiceNote(order.note);
        setReference(order.reference);

        let defaultProvider = null;
        let defaultMethod = null;
        try {
          const shippingSettingsRes = await middleware.get('settings/shipping');
          defaultProvider = shippingSettingsRes.data.data?.default_provider_id || null;
          defaultMethod = shippingSettingsRes.data.data?.default_provider_method_id || null;
        } catch (err) {
          // settings niet gevonden, geen probleem
        }

        const providersResponse = await middleware.get(`shipments/providers`);
        const providers = providersResponse.data
          .filter(provider => provider.provider_in_use === 1)
          .map(provider => ({
            ...provider,
            methods: provider.methods ? provider.methods.filter(m => m.method_in_use === 1) : []
          }));
        setProviders(providers);

        if (defaultProvider && providers.some(p => p.provider_id == defaultProvider)) {
          setSelectedProvider(Number(defaultProvider));
        } else {
          setSelectedProvider(null);
        }

        setTimeout(() => {
          if (
            defaultMethod &&
            providers
              .filter(p => p.provider_id == defaultProvider)
              .flatMap(p => p.methods)
              .some(m => m.provider_method_id == defaultMethod)
          ) {
            setSelectedMethod(Number(defaultMethod));
          } else {
            setSelectedMethod(null);
          }
        }, 100);

        const customerType = order.internal_id.charAt(0) === "C" ? 'consumers' : 'businesses';
        const { internal_id } = order;

        const [
          customerResponse,
          emailResponse,
          phoneNumberResponse,
        ] = await Promise.all([
          middleware.get(`${customerType}?internal_id=${internal_id}`),
          middleware.get(`emails?internal_id=${internal_id}`),
          middleware.get(`phonenumbers?internal_id=${internal_id}`),
        ]);

        const addressResponse = await middleware.get(`addresses?internal_id=${order.internal_id}`);
        if (addressResponse.data.data.length > 0) {
          const countryCodesResponse = await middleware.get(`countryCodes`);
          addressResponse.data.data.map((address) => {
            address.country = countryCodesResponse.data.data.find((countryCode) => countryCode.country_code_id === address.country_code_id).country_code_2;
            if (address.address_kind === AddressKinds.DELIVERY_ADDRESS || address.address_kind === AddressKinds.DELIVERY_AND_INVOICE_ADDRESS) {
              setDeliveryAddress(address);
            } else if (address.address_kind === AddressKinds.INVOICE_ADDRESS || address.address_kind === AddressKinds.DELIVERY_AND_INVOICE_ADDRESS) {
              setInvoiceAddress(address);
            }

          });
        }
        const soldProductsData = order.orders_sold_products;
        setSoldProducts(soldProductsData);
        setCustomer(customerResponse.data.data[0] || {});
        setEmails(emailResponse.data.data || []);
        setPhoneNumbers(phoneNumberResponse.data.data || []);

        // If there are products that are not proccessed it adds them to the products to proccess. It also calculates how many products where bought in the order
        const addToProcces = [];
        const addToProccessingProducts = {};
        soldProductsData.map(soldProduct => {
          if (soldProduct.amount > soldProduct.items_processed) {
            addToProccessingProducts[soldProduct.sold_product_id] = (soldProduct.amount - soldProduct.items_processed - soldProduct.items_credited);
            addToProcces.push(soldProduct);
          }
        });
        setProductsToProcces(addToProcces);
        setProccessingProducts(addToProccessingProducts);

        // If everything has been proccessed you can't access this page
        if (Object.values(addToProccessingProducts).length === 0) {
          ToastWarning(`Alles is al verwerkt`);
          navigate(`/bestellingen/overzicht/${order_number}`);
        }

        setPageIsLoading(false);

      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    setShowShipmentMethod(selectedProvider ? true : false);
  }, [selectedProvider]);

  const changeProductProccessingAmount = (event, productToProcces) => {
    let value = event.target.value;
    if (value === '') {
      value = 0;
    }

    value = parseInt(value, 10);
    const max = productToProcces.amount - productToProcces.items_processed - productToProcces.items_credited;

    if (value > max) {
      setProccessingProducts({ ...proccessingProducts, [productToProcces.sold_product_id]: max });
    } else {
      setProccessingProducts({ ...proccessingProducts, [productToProcces.sold_product_id]: value });
    }
  }

  const proccessProducts = async (event,action=null) => {
    event.preventDefault();

    // Prevent multiple simultaneous executions
    if (isProcessing) {
      ToastWarning('Producten worden al verwerkt, even geduld...');
      return;
    }

    try {
      const soldProductsToUpdate = [];
      productsToProcces.forEach(productToProcces => {
        const selectedProcessingAmount = proccessingProducts[productToProcces.sold_product_id];
        if (selectedProcessingAmount > 0) {
          soldProductsToUpdate.push({
            sold_product_id: productToProcces.sold_product_id,
            amount_to_process: selectedProcessingAmount
          });
        }
      });

      // Validation checks
      if (soldProductsToUpdate.length === 0) {
        ToastError(`Er zijn geen producten geselecteerd om te verwerken`, 'no_products_selected');
        return;
      }

      if (deliveryAddress === null) {
        ToastError(`Er is geen bezorgadres geselecteerd`, 'no_delivery_address_selected');
        return;
      }

      if (!selectedProvider && makeNewPackage) {
        ToastError(`Er is geen provider geselecteerd`, 'no_provider_selected');
        return;
      }

      if (!selectedMethod && makeNewPackage) {
        ToastError(`Er is geen verzendmethode geselecteerd`, 'no_method_selected');
        return;
      }

      setIsProcessing(true);

      // Create the API promise
      const apiPromise = middleware.post(`myparcel/shipments`, {
        data: {
          order_id: order.order_id,
          proccessedProducts: soldProductsToUpdate,
          shipment_provider_id: selectedProvider,
          shipment_method_id: selectedMethod,
          invoice_note: invoiceNote,
          reference: reference,
        },
        packages: packages
      });

      // Use ToastPromise for the API call
      const result = await ToastPromise({
        promise: apiPromise,
        pending: 'Producten worden verwerkt...',
        successRenderer: (data) => {
          // Return the success message immediately, handle invoice generation separately
          return `${soldProductsToUpdate.length} product(en) succesvol verwerkt! 📦`;
        },
        errorRenderer: (err) => {
          console.error(err);
          
          if (err.response?.data?.errors) {
            // Return first error message for toast, log all errors
            err.response.data.errors.forEach((error, index) => {
              if (index > 0) {
                // Show additional errors as separate error toasts
                setTimeout(() => ToastError(`Verwerkingsfout: ${error}`), 100 * index);
              }
            });
            return `Verwerkingsfout: ${err.response.data.errors[0]}`;
          }
          
          return `Onbekende fout bij verwerken van producten: ${err.message || 'Als dit probleem vaker voorkomt neem contact op met onze support medewerkers.'}`;
        }
      });

      // Generate invoice after successful processing
      try {
        await generateInvoice([order.order_id], false, false, true);
      } catch (invoiceError) {
        console.error('Invoice generation failed:', invoiceError);
        // Show error if invoice generation fails
        setTimeout(() => ToastError('Producten succesvol verwerkt, maar factuur genereren is mislukt. Je kunt handmatig een factuur genereren.'), 500);
      }

      const actionstring = action?"?action="+action:"";
      // Navigate after everything is done
      navigate(`/bestellingen/overzicht/${order_number}`+actionstring);

      // Success actions - only executed if promise resolves
      setPageIsLoading(false);

    } catch (error) {
      // This catch handles validation errors and other non-API errors
      // API errors are handled by ToastPromise
      console.error(error);
      if (!error.response) {
        // Only show toast for non-API errors (validation errors are already shown above)
        ToastError(`Onverwachte fout opgetreden: ${error.message || 'Probeer het opnieuw'}`);
      }
    } finally {
      // Always reset loading state
      setIsProcessing(false);
    }
  };

  const [companyAddress, setCompanyAddress] = useState({});
  useEffect(() => {
    async function fetchData() {
      const companyAddressResponse = await middleware.get('settings/backoffice');
      setCompanyAddress(companyAddressResponse.data.data[0]);
    }

    fetchData();
  }, []);

  useEffect(() => {
    // Load packages in an array in advance to adding order
    const pkgbuf = [];
    for (let i = 0; i < packageAmount; i++) {
      pkgbuf.push({
        method_id: selectedMethod,
        provider_id: selectedProvider,
        options: {
          package_type: 1,
        }
      })
    }
    setPackages(pkgbuf);
  }, [selectedMethod, selectedProvider, packageAmount]);

  const baseWidth = 3;
  const minWidth = 1;
  const calculatedWidth = Math.max(
    minWidth,
    Math.round(baseWidth * (10 / Math.max(10, barcode.length)))
  );

  useEffect(() => {
    // const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    if (barcode) {
      let canvas;
      canvas = document.createElement('canvas');
      JsBarcode(canvas, barcode, {
        format: 'CODE128',
        width: calculatedWidth,
        height: 75
      });
      const barcodecanvas = canvas.toDataURL();

      setBarcodeURL(barcodecanvas);
    }
  }, [barcode]);

  // Filter providers that are in use only
  const providerOptions = [
    { value: null, title: "Selecteer provider" },
    ...providers.map((provider) => ({
      value: provider.provider_id,
      title: provider.provider_name
    }))
  ];

  // Filter methods for selected provider - only show methods that are in use
  const providerChoicesOptions = [
    { value: null, title: "Selecteer verzendmethode" },
    ...providers
      .filter(provider => provider.provider_id === selectedProvider)
      .flatMap(provider => provider.methods)
      .map(method => ({
        value: method.provider_method_id,
        title: method.name
      }))
  ];

  // Auto-select method if only one option available (skip if placeholder only)
  useEffect(() => {
    const realOptions = providerChoicesOptions.filter(opt => opt.value !== null);
    if (selectedProvider && realOptions.length === 1) {
      setSelectedMethod(realOptions[0].value);
    }
  }, [selectedProvider, providerChoicesOptions]);

  return (
    <PageTemplate pageIsLoading={pageIsLoading} navbarTitle={"Order HUB"}>
      <div className='w-100'>
        <div className="d-flex flex-row mb-3 justify-content-between">
          <BackButton
            text={`Verwerk bestelling #${order.order_number}`}
            onClickFunction={() => navigate("/bestellingen/overzicht/" + order_number)}
          />
          <div className='d-flex align-items-center gap-1'>
          <ButtonBlue onClickFunction={(event) => proccessProducts(event)} text="Verwerk order"/>
          <ButtonBlue onClickFunction={(event) => proccessProducts(event,1)} text="Verwerk order & pakbon downloaden"/>
          {exportShippingInstalled?.apps?.find(app => app.slug === "shipping-export")?.status ===3? <ButtonBlue onClickFunction={(event) => proccessProducts(event,2)} text={<span>Verwerk order & pakbon downloaden <br/>& bezorgadres exporteren</span>}/>:""}
</div>
        </div>
        <div className="d-flex justify-content-between parentBoxes w-100 row">
          <div className='proccessOrdersContainer d-flex flex-column col-8'>
            <div className='me-3 mb-3'>
              {soldProducts.length > 0 ? (
                <div className="bg-white rounded-4 p-4 mb-3">
                  <div>
                    <h5 className='fw-bold'>Items om te verwerken</h5>
                  </div>

                  <div>
                    <table className='w-100 border-0 mb-0'>
                      <thead className='bottom-border-gray'>
                        <tr>
                          <th>Producten</th>
                          <th>Aantal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productsToProcces.map((productToProcces, index) => (
                          <tr key={index} className='bottom-border-gray'>
                            <td className="text-start  w-75">
                              <div className='d-flex align-items-center linkColor'>
                                <div className='px-4 py-2'>
                                  {productToProcces.image ? (
                                    <img
                                      src={`${middleware.defaults.imagesBaseURL}${productToProcces.image.path}`}
                                      className="rounded-circle p-2"
                                      height={100}
                                      width={100}
                                      alt="placeholder..."
                                    />
                                  ) : (
                                    <img
                                      src={placeholder}
                                      className="rounded-circle p-2"
                                      height={100}
                                      width={100}
                                      alt="placeholder..."
                                    />
                                  )}

                                </div>
                                <div>
                                  {productToProcces.product_name.length > 100 ? (
                                    productsToProccesFullyShown[index] === undefined ? (
                                      <>
                                        <span className='linkColor'>
                                          {productToProcces.product_name.slice(0, 90)}
                                        </span>
                                        <span
                                          className="text-info hover text-nowrap ms-2"
                                          onClick={() => setProductsToProccesFullyShown([...productsToProccesFullyShown, index])}>
                                          (...)
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className='linkColor'>
                                          {productToProcces.product_name}
                                        </span>
                                        <span
                                          className="text-info hover text-nowrap ms-2"
                                          onClick={() => setProductsToProccesFullyShown(productsToProccesFullyShown.filter(i => i !== index))}>
                                          Toon minder
                                        </span>
                                      </>
                                    )
                                  ) : (
                                    productToProcces.product_name
                                  )}

                                  {productToProcces.product_description && (
                                    <p className="text-muted small mb-0">
                                      {productToProcces.product_description?.length < 100
                                        ? productToProcces.product_description
                                        : (productToProcces.product_description?.slice(0, 90) ??
                                            "") + "..."}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className='d-flex'>
                                <input
                                  className='stockInput standardInput fw-semibold'
                                  type='text'
                                  value={proccessingProducts[productToProcces.sold_product_id]}
                                  pattern="[0-9]*"
                                  onChange={(event) => changeProductProccessingAmount(event, productToProcces)}
                                />
                                <div className='stockInput2 standardInput'>van {productToProcces.amount - productToProcces.items_processed - productToProcces.items_credited}</div>
                                <div className='stockInput3 standardInput'>{productToProcces?.stock?.warehouse_quantity} op voorraad</div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6 mb-4">
                      <div className="fw-bold mb-2">Opmerking op factuur</div>
                      <textarea
                        className="form-control rounded-4"
                        rows="4"
                        placeholder="Opmerking op factuur"
                        value={invoiceNote ?? ''}
                        onChange={(e) => setInvoiceNote(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="fw-bold mb-2">Extra informatie</div>
                      <textarea
                        className="form-control rounded-4"
                        rows="4"
                        placeholder="Referentie op factuur"
                        value={reference ?? ''}
                        onChange={(e) => setReference(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-white rounded-4 p-4 mb-3">
                  <h1>Deze bestelling heeft geen verkochte producten</h1>
                </div>
              )}
            </div>
            <div className='me-3'>
              <div className='bg-white rounded-4 p-4 mb-3 px-4'>
                <div className='mb-3 d-flex justify-content-between'>
                  <h5 className='fw-semibold'>
                    Pakketlabel aanmaken
                  </h5 >
                  {/* <label className="switchNewCustomer me-2">
                    <input type="checkbox" defaultChecked onClick={() => setMakeNewPackage(!makeNewPackage)} />
                    <span className="sliderNewCustomer  round"></span>
                  </label> */}
                </div>
                <div className='row'>
                  <div className='d-flex flex-column pb-3 col-4'>
                    <div className='d-flex align-items-center'>
                      <div className=''>
                        <p className='pt-2 mb-1 fw-semibold'>Bezorgadres</p>
                        <div className='p-0'>
                          {deliveryAddress ? (
                            <>
                              <p className='mb-0'>{customer.first_name} {customer.last_name}</p>
                              <p className='mb-0'>{deliveryAddress.streetname} {deliveryAddress.housenumber} </p>
                              <p className='mb-0'>{deliveryAddress.postalcode} {deliveryAddress.city} </p>
                            </>
                          ) : (
                            <>
                              <p>Geen adres</p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <form className='col-4' onSubmit={proccessProducts}>
                    {makeNewPackage ? (
                      <>
                        <div className=''>
                          <p className='fw-semibold pt-2 mb-1'>Pakket provider</p>
                          <BorderedDropDown
                            placeholder="Selecteer een provider"
                            options={providerOptions}
                            selectedValue={selectedProvider}
                            setSelectedValue={(value) => {setSelectedProvider(value); setSelectedMethod(null)}}
                          />
                          {showShipmentMethod &&
                            <>
                              <p className='fw-semibold pt-2 mb-1'>Verzendmethode</p>
                              <BorderedDropDown
                                placeholder="Selecteer een verzendmethode"
                                options={providerChoicesOptions}
                                selectedValue={selectedMethod}
                                setSelectedValue={setSelectedMethod}
                              />
                            </>
                          }
                        </div>
                      </>
                    ) : (
                      <div className='mb-3 alert alert-info'>
                        <p>
                          <FontAwesomeIcon className='text-info' icon={faCircleInfo} /> {' '}
                          Er wordt nu geen pakket aangemaakt, maar je kunt later altijd pakket toevoegen.
                        </p>
                      </div>
                    )}
                  </form>
                  <div className='col-4 px-2'>
                    {/*<div className='d-flex flex-column ms-5'>
                      <p className='pt-2 mb-1 d-flex fw-semibold justify-content-center' >Aantal pakketten</p>
                      <div className='d-flex pb-2 justify-content-center'>
                        <input
                          type='number'
                          className='standardInput packagesInput'
                          min={1}
                          required
                          value={packageAmount}
                          onChange={event => setPackageAmount(event.target.value)}
                        />
                      </div>
                    </div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='whiteBox col-4 px-4 p-4 d-flex flex-column h-100'>
            <CustomerComponent
              mode="show"
              editable={false}
              customer={customer}
              order={order}
              emails={emails}
              setOrder={setOrder}
              phoneNumbers={phoneNumbers}
              setDeliveryAddress={setDeliveryAddress}
              deliveryAddress={deliveryAddress}
              invoiceAddress={invoiceAddress}
            />
          </div>
        </div>
      </div>
    </PageTemplate>
  );
}

export default ProccessOrders;